export default __webpack_public_path__ + "static/media/404-1.c9f5e61b.svg";